import React from "react";
import { useNavigate } from "react-router-dom";

function sectionId(heading) {
  return heading.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
}

function Block({ block }) {
  if (block.type === "list") {
    return (
      <ul>
        {block.items.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    );
  }

  if (block.type === "table") {
    return (
      <div style={{ overflowX: "auto", margin: "18px 0" }}>
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            minWidth: "620px"
          }}
        >
          <thead>
            <tr>
              {block.headers.map((header) => (
                <th
                  key={header}
                  scope="col"
                  style={{
                    textAlign: "left",
                    borderBottom: "1px solid rgba(15, 23, 42, 0.22)",
                    padding: "10px 12px",
                    verticalAlign: "top"
                  }}
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {block.rows.map((row, rowIndex) => (
              <tr key={`${rowIndex}-${row[0]}`}>
                {row.map((cell, cellIndex) => (
                  <td
                    key={`${rowIndex}-${cellIndex}`}
                    style={{
                      borderBottom: "1px solid rgba(15, 23, 42, 0.12)",
                      padding: "10px 12px",
                      verticalAlign: "top"
                    }}
                  >
                    {cell}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  return <p>{block.text}</p>;
}

export default function LegalDocumentPage({ document }) {
  const nav = useNavigate();
  const bodyBlocks = Array.isArray(document.bodyBlocks) ? document.bodyBlocks : [];
  const sections = Array.isArray(document.sections) ? document.sections : [];

  return (
    <div className="ft-legalPage">
      <div className="ft-legalTopBar">
        <button type="button" className="ft-legalBack" onClick={() => nav(-1)}>
          Back
        </button>
        <div className="ft-subtle">Flowtrak Legal</div>
      </div>

      <article className="ft-legalCard" aria-labelledby="legal-document-title">
        <div className="ft-legalHead">
          <h1 id="legal-document-title" className="ft-legalTitle">
            {document.title}
          </h1>
          <div className="ft-legalMeta">
            <div>Version: {document.version}</div>
            <div>Effective Date: {document.effectiveDate}</div>
            <div>Last Updated: {document.lastUpdated}</div>
            <div>{document.company.name}</div>
          </div>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "10px",
              marginTop: "18px"
            }}
          >
            <button type="button" className="ft-btn" onClick={() => window.print()}>
              Print
            </button>
            <a className="ft-btn ft-btn--secondary" href={document.pdfPath}>
              Download PDF
            </a>
          </div>
        </div>

        <div className="ft-legalBody">
          {sections.length ? (
            <nav aria-label={`${document.title} sections`} style={{ marginBottom: "26px" }}>
              <h2>Sections</h2>
              <ol>
                {sections.map((section) => (
                  <li key={section.heading}>
                    <a href={`#${sectionId(section.heading)}`}>{section.heading}</a>
                  </li>
                ))}
              </ol>
            </nav>
          ) : null}

          {document.intro.map((paragraph) => (
            <p key={paragraph}>{paragraph}</p>
          ))}

          {bodyBlocks.map((block, index) => (
            <Block key={`body-${index}`} block={block} />
          ))}

          {sections.map((section) => (
            <section key={section.heading} id={sectionId(section.heading)}>
              <h2>{section.heading}</h2>
              {section.blocks.map((block, index) => (
                <Block key={`${section.heading}-${index}`} block={block} />
              ))}
            </section>
          ))}

          <section aria-labelledby="legal-contact-heading">
            <h2 id="legal-contact-heading">Company Information</h2>
            <p>{document.company.name}</p>
            <address style={{ fontStyle: "normal" }}>
              {document.company.noticeAddress.map((line) => (
                <React.Fragment key={line}>
                  {line}
                  <br />
                </React.Fragment>
              ))}
              <a href={`mailto:${document.company.email}`}>{document.company.email}</a>
            </address>
          </section>
        </div>
      </article>
    </div>
  );
}
